import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: true,
  transcript: [],
  playedHighlight: null,
  isSwitchModeActive: false,
  query: '',
  selectedSearchItemId: null,
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'transcripts',
  initialState,
  reducers: {
    initialStateAction: () => initialState,
    setLoadingStateAction: (state, action) => {
      state.isLoading = action.payload;
    },
    setTranscriptQueryAction: (state, action) => {
      state.query = action.payload;
    },
    setSelectedSearchItemIdAction: (state, action) => {
      state.selectedSearchItemId = action.payload;
    },
    getTranscriptAction: (state) => state,
    setPlayedHighlightAction: (state, action) => {
      state.playedHighlight = action.payload;
    },
    setSwitchModeAction: (state, action) => {
      state.isSwitchModeActive = action.payload;
    },
    setTranscriptAction: (state, action) => {
      state.transcript = action.payload.map((item) => ({
        ...item,
      }));
      state.isLoading = false;
    },
    errorTranscriptAction: (state) => state,
  },
});

export const {
  initialStateAction,
  setLoadingStateAction,
  setPlayedHighlightAction,
  getTranscriptAction,
  setTranscriptAction,
  errorTranscriptAction,
  setSwitchModeAction,
  setTranscriptQueryAction,
  setSelectedSearchItemIdAction,
} = slice.actions;
